<div class="container-fluid mt-4">
  
  <mat-divider class="mb-4"></mat-divider>
  <p class="text-info-emphasis ">Se requiere un mínimo de 3 Liquidaciones de sueldo para los trabajadores dependientes o 3 boletas de honorarios 
    para los trabajadores independientes.</p>
  <div *ngFor="let documento of documentForm.controls; let i = index">
    <form [formGroup]="documentForm.controls[i]" class="row ">
      <div class="col-md-6" *ngIf="!documento.get('guid')?.value">
        <input type="file" [id]="'documento' + i" class="form-control" formControlName="archivo" (change)="onFileChange($event, i)" accept=".jpeg, .jpg, .pdf">
      </div>
      <div class="col-md-6" *ngIf="documento.get('guid')?.value">
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>Documento</mat-label>
          <input matInput type="text" [id]="'documento' + i" formControlName="archivoNombre" readonly>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>Tipo Documento</mat-label>
          <mat-select class="mt-2" formControlName="tipo">
            <mat-option *ngFor="let doc of getTipoBienesRaices()" [value]="doc">{{ tipo[doc]}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <button mat-icon-button color="warn" type="button" (click)="eliminarDocumento(i, documento)" [disabled]="formFirmado">
        <mat-icon>delete</mat-icon>
      </button>
      <mat-divider class="mb-4"></mat-divider>
    </form>
  </div>
  <div class="row">
    <div class="mt-4">
      <button mat-raised-button color="accent" type="button" class="ml1 mr1 fl" (click)="agregarDocumento(null)"><mat-icon >add_circle</mat-icon> Agregar Documento</button>
      <button id="pasivosSiguienteBtn" class="ml1 mr1 fr" mat-raised-button color="primary" (click)="onSubmit()">Siguiente</button>
      <button id="pasivosVolver" type="button" mat-raised-button color="secundary" class="ml1 mr1 fr" (click)="volver()">Volver</button>
    </div>
</div>
</div>
